const WIDGET_PREVIEW_DATA = Object.freeze({
  activity: {
    items: [
      {
        id: 'p1',
        type: 'call',
        title: 'Title of the activity',
        description: 'Customer requested a follow-up call.',
        author: 'Robert Chen',
        timeAgo: '4h ago',
        alerts: [{ type: 'needs_attention', message: 'Follow-up required' }],
        metadata: {
          userId: 'usr-001',
          sentiment: 'positive',
          assignedTasks: 2,
          hasRecording: true,
          hasExternalLink: true,
          direction: 'outbound',
          duration: '4 mins',
          flagged: true,
        },
      },
      {
        id: 'p2',
        type: 'email',
        title: 'Title of the activity',
        description: 'Additional warranty information requested.',
        author: 'Maria Garcia',
        timeAgo: '4h ago',
        metadata: {
          userId: 'usr-002',
          commentsCount: 7,
          attachmentsCount: 3,
          assignedTasks: 2,
          hasExternalLink: true,
          flagged: true,
        },
      },
      {
        id: 'p3',
        type: 'call',
        title: 'Title of the activity',
        description: 'Technical support regarding the mobile app.',
        timeAgo: '1d ago',
        alerts: [{ type: 'expired', message: 'Task expired' }],
        metadata: {
          userId: 'usr-003',
          duration: '12 mins',
          hasExternalLink: true,
          flagged: true,
        },
      },
      {
        id: 'p4',
        type: 'sms',
        title: 'Title of the activity',
        description: 'Appointment confirmation sent.',
        timeAgo: '2d ago',
        metadata: {
          userId: 'usr-004',
          commentsCount: 7,
          attachmentsCount: 3,
          assignedTasks: 2,
          hasExternalLink: true,
          linkCount: 1,
          flagged: true,
        },
      },
      {
        id: 'p5',
        type: 'email',
        title: 'Internal handoff',
        description: 'Sales → service: vehicle prep checklist attached.',
        author: 'Ana Lopez',
        timeAgo: '3d ago',
        metadata: {
          userId: 'usr-005',
          commentsCount: 1,
          assignedTasks: 0,
          hasExternalLink: false,
          flagged: false,
        },
      },
    ],
  },
  notes: {
    items: [
      {
        id: 'p1',
        title: 'Customer appointment reminder',
        description: 'Follow-up call to discuss financing options.',
        dueDate: 'Mar 4',
        author: 'David Kim',
        timeAgo: '4h ago',
        metadata: { commentsCount: 7, attachmentsCount: 3, tasksCount: 2 },
      },
      {
        id: 'p2',
        title: 'Financing options discussion',
        description: 'Reviewed 60-month vs 72-month terms.',
        dueDate: 'Mar 2',
        author: 'Maria Garcia',
        timeAgo: '1d ago',
        metadata: { commentsCount: 2, attachmentsCount: 1, tasksCount: 0 },
      },
      {
        id: 'p3',
        title: 'Test drive scheduled',
        description: 'Confirmed for Saturday 10am.',
        dueDate: 'Feb 24',
        author: 'Robert Chen',
        timeAgo: '2d ago',
        metadata: { commentsCount: 0, attachmentsCount: 0, tasksCount: 1 },
      },
      {
        id: 'p4',
        title: 'Trade-in valuation requested',
        description: 'VIN and mileage sent; awaiting appraisal.',
        dueDate: 'Feb 22',
        author: 'Ana Lopez',
        timeAgo: '3d ago',
        metadata: { commentsCount: 4, attachmentsCount: 2, tasksCount: 1 },
      },
      {
        id: 'p5',
        title: 'Insurance quote follow-up',
        description: 'Customer comparing comprehensive vs liability.',
        dueDate: 'Feb 20',
        author: 'David Kim',
        timeAgo: '5d ago',
        metadata: { commentsCount: 1, attachmentsCount: 0, tasksCount: 0 },
      },
    ],
  },
  appointments: {
    title: 'Appointments',
    items: [
      { id: 'p-1', content: 'Test drive - Tuesday 10:00' },
      { id: 'p-2', content: 'Finance consultation - Wednesday 14:00' },
      { id: 'p-3', content: 'Service drop-off - Thursday 08:30' },
      { id: 'p-4', content: 'Delivery walkthrough - Friday 16:00' },
      { id: 'p-5', content: 'Accessory install - next Mon 11:00' },
    ],
  },
  tasks: {
    title: 'Tasks',
    items: [
      { id: 't-1', content: 'Send quote' },
      { id: 't-2', content: 'Update CRM stage' },
      { id: 't-3', content: 'Schedule follow-up call' },
      { id: 't-4', content: 'Verify trade-in documents' },
      { id: 't-5', content: 'Confirm insurance binder' },
    ],
  },
  pipeline: {
    title: 'Pipeline Overview',
    items: [
      { id: 'pl-1', content: 'Qualified leads: 18' },
      { id: 'pl-2', content: 'Proposals: 7' },
      { id: 'pl-3', content: 'Closed won: 3' },
      { id: 'pl-4', content: 'Avg cycle: 14 days' },
      { id: 'pl-5', content: 'At risk: 4 deals' },
    ],
  },
  aiInsights: {
    title: 'AI Insights',
    items: [
      { id: 'ai-1', content: 'High churn risk on 2 accounts' },
      { id: 'ai-2', content: 'Best contact window: Tue 10-12' },
      { id: 'ai-3', content: 'Upsell: extended warranty on 3 open deals' },
      { id: 'ai-4', content: 'Reply sentiment trending up vs last week' },
      { id: 'ai-5', content: 'Suggested next step: book service for VIN …482' },
    ],
  },
  emails: {
    title: 'Emails',
    items: [
      { id: 'em-1', content: 'Re: Financing options — awaiting reply' },
      { id: 'em-2', content: 'Service appointment confirmation' },
      { id: 'em-3', content: 'Fwd: OEM incentive program — ends 28th' },
      { id: 'em-4', content: 'Re: Trade-in photos received' },
      { id: 'em-5', content: 'Internal: rate sheet update for March' },
    ],
  },
  chat: {
    title: 'Chat',
    items: [
      { id: 'ch-1', content: 'Customer: Can we reschedule?' },
      { id: 'ch-2', content: 'Agent: Yes, I’ll send slots.' },
      { id: 'ch-3', content: 'Customer: Do you have the blue in stock?' },
      { id: 'ch-4', content: 'Agent: Two units — want to hold one?' },
      { id: 'ch-5', content: 'Customer: Send me the out-the-door number.' },
    ],
  },
  followUps: {
    title: 'Follow-ups',
    items: [
      { id: 'fu-1', content: 'Call back — pricing questions' },
      { id: 'fu-2', content: 'Send brochure — EV models' },
      { id: 'fu-3', content: 'Text reminder — test drive tomorrow' },
      { id: 'fu-4', content: 'Email recap — warranty options' },
      { id: 'fu-5', content: 'Check credit app status with lender' },
    ],
  },
  conversionFunnel: {
    title: 'Conversion Funnel',
    items: [
      { id: 'cf-1', content: 'Lead → Qualified: 38%' },
      { id: 'cf-2', content: 'Qualified → Won: 12%' },
      { id: 'cf-3', content: 'Top drop-off: financing step' },
      { id: 'cf-4', content: 'Mobile vs desktop: +6% mobile' },
      { id: 'cf-5', content: 'Avg touches to close: 5.2' },
    ],
  },
  performanceScore: {
    title: 'Performance Score',
    items: [
      { id: 'ps-1', content: 'Score: 87 · +3% vs last period' },
      { id: 'ps-2', content: 'Benchmark: team avg 82' },
      { id: 'ps-3', content: 'Response time: 12m (goal <15m)' },
      { id: 'ps-4', content: 'Tasks cleared: 94%' },
      { id: 'ps-5', content: 'CSAT (rolling 30d): 4.6/5' },
    ],
  },
  sentiment: {
    title: 'Sentiment',
    items: [
      { id: 'se-1', content: 'Last 30 days: mostly positive' },
      { id: 'se-2', content: 'Recent shift: neutral on pricing' },
      { id: 'se-3', content: 'Calls: 62% positive / 28% neutral / 10% neg' },
      { id: 'se-4', content: 'Email tone: stable vs prior month' },
      { id: 'se-5', content: 'Alert: spike in “wait time” mentions' },
    ],
  },
});

export default WIDGET_PREVIEW_DATA;
